export function CheckmarkFill() {
  return (
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.0624 4.65968C23.7107 5.33883 23.6856 6.41491 23.0065 7.06319L10.1736 19.396C9.84224 19.7123 9.39731 19.8815 8.93956 19.8652C8.48181 19.849 8.04997 19.6488 7.74186 19.3099L1.47208 12.5406C0.84052 11.8459 0.891719 10.7707 1.58644 10.1391C2.28115 9.50757 3.35632 9.55877 3.98788 10.2535L9.08594 15.7339L20.6589 4.60378C21.338 3.95551 22.4141 3.98053 23.0624 4.65968Z" fill="currentColor"/>
</svg>

  );
}
